import _ from "underscore";
import utils from "core/utils";
import UIControl from "app/components/common/editor/control/ui-control";
import BaseEditor from "app/components/common/editor/meta-object-editors/base";
import MetaObjectDataSource from "app/components/common/editor/control/select/metaobject-datasource";
import metaStoreService from "core/services/metaStoreService/meta-store-service";

var Module = function(metadata_object, options) {
    options = options || {};
    options.displayFields = options.displayFields || ["adapter", "from", "output", "enrichment"];
    options.optionalFields = options.optionalFields || ["from", "output"];
    options.subType = "Open Processor";

    BaseEditor.apply(this, arguments);
};

Module.prototype = _.extend({}, BaseEditor.prototype, {
    addCustomFields: function() {
        this.fieldMapper.adapter = UIControl.PropertyTemplate("process")
            .extend({
                subControl: true,
                hideLabel: true
            })
            .create();

        var inputDataSource = new MetaObjectDataSource([utils.ENTITIES.STREAM, utils.ENTITIES.CACHE]);
        this.fieldMapper.from = UIControl.Select(inputDataSource, {}).create();

        this.fieldMapper.output = UIControl.StreamSelector.extend({
            required: false,
            typesToShow: [metaStoreService.entities.STREAM, metaStoreService.entities.WINDOW]
        }).create();

        var caches = new MetaObjectDataSource([utils.ENTITIES.CACHE]);
        this.fieldMapper.enrichment = UIControl.Select(caches, {
            addNew: false,
            multiple: true,
            plceholder: "Choose enrichment",
            type: utils.ENTITIES.CACHE
        }).create();
    },
    postRender: function() {}
});

export default Module;
